var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLandscapeLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 50,
    viewBox: "0 0 118 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Omni hub logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.024 0H36.4829V11.971H49.024V0Z",
    fill: "url(#paint0_linear_1559_11397)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4827 0H24.5117V11.971H36.4827V0Z",
    fill: "url(#paint1_linear_1559_11397)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5123 0H11.9712V11.971H24.5123V0Z",
    fill: "url(#paint2_linear_1559_11397)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.971 0H0V11.971H11.971V0Z",
    fill: "url(#paint3_linear_1559_11397)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.024 11.9707H36.4829V24.5118H49.024V11.9707Z",
    fill: "url(#paint4_linear_1559_11397)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4827 11.9707H24.5117V24.5118H36.4827V11.9707Z",
    fill: "url(#paint5_linear_1559_11397)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5123 11.9707H11.9712V24.5118H24.5123V11.9707Z",
    fill: "url(#paint6_linear_1559_11397)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.971 11.9707H0V24.5118H11.971V11.9707Z",
    fill: "url(#paint7_linear_1559_11397)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.024 36.4824H36.4829V49.0235H49.024V36.4824Z",
    fill: "url(#paint8_linear_1559_11397)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4827 36.4824H24.5117V49.0235H36.4827V36.4824Z",
    fill: "url(#paint9_linear_1559_11397)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5123 36.4824H11.9712V49.0235H24.5123V36.4824Z",
    fill: "url(#paint10_linear_1559_11397)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.971 36.4824H0V49.0235H11.971V36.4824Z",
    fill: "url(#paint11_linear_1559_11397)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M49.024 24.5127H36.4829V36.4837H49.024V24.5127Z",
    fill: "url(#paint12_linear_1559_11397)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4827 24.5127H24.5117V36.4837H36.4827V24.5127Z",
    fill: "url(#paint13_linear_1559_11397)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5123 24.5127H11.9712V36.4837H24.5123V24.5127Z",
    fill: "url(#paint14_linear_1559_11397)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.971 24.5127H0V36.4837H11.971V24.5127Z",
    fill: "url(#paint15_linear_1559_11397)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6504 43.6865H85.1974V36.8321H78.2797V43.6865H75.8164V28.5029H78.2797V34.7135H85.1974V28.5029H87.6504V43.6865Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M103.405 28.5029V38.3276C103.405 39.3869 103.183 40.3355 102.738 41.1732C102.3 42.011 101.636 42.6757 100.747 43.1672C99.8573 43.6519 98.7385 43.8942 97.3906 43.8942C95.4679 43.8942 94.0036 43.3853 92.9977 42.3676C91.9988 41.3429 91.4993 39.9824 91.4993 38.2861V28.5029H93.9625V38.068C93.9625 39.335 94.2568 40.2697 94.8452 40.8721C95.4336 41.4744 96.3129 41.7756 97.483 41.7756C98.2904 41.7756 98.9472 41.6337 99.4536 41.3498C99.9668 41.059 100.343 40.6367 100.583 40.0828C100.829 39.5219 100.952 38.8469 100.952 38.0576V28.5029H103.405Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M107.244 28.5029H111.708C113.645 28.5029 115.106 28.7868 116.091 29.3545C117.076 29.9223 117.569 30.902 117.569 32.2936C117.569 32.8752 117.466 33.4014 117.261 33.8722C117.063 34.3361 116.772 34.7204 116.389 35.025C116.005 35.3227 115.533 35.5235 114.972 35.6274V35.7312C115.554 35.8351 116.07 36.0186 116.522 36.2817C116.98 36.5448 117.34 36.9221 117.6 37.4137C117.867 37.9053 118 38.5422 118 39.3246C118 40.2524 117.781 41.0417 117.343 41.6925C116.912 42.3433 116.293 42.8384 115.485 43.1776C114.685 43.5169 113.734 43.6865 112.632 43.6865H107.244V28.5029ZM109.707 34.7654H112.068C113.183 34.7654 113.956 34.5819 114.387 34.215C114.818 33.848 115.034 33.3114 115.034 32.6052C115.034 31.8851 114.777 31.3659 114.264 31.0474C113.758 30.7289 112.95 30.5696 111.842 30.5696H109.707V34.7654ZM109.707 36.7802V41.599H112.304C113.453 41.599 114.261 41.374 114.726 40.924C115.191 40.4739 115.424 39.8647 115.424 39.0961C115.424 38.6253 115.318 38.2168 115.106 37.8706C114.9 37.5245 114.562 37.2579 114.09 37.071C113.617 36.8771 112.981 36.7802 112.18 36.7802H109.707Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1109 9.97081C75.1109 11.123 74.963 12.173 74.6672 13.1207C74.3783 14.0615 73.9415 14.8728 73.3568 15.5546C72.772 16.2296 72.0394 16.7512 71.1589 17.1193C70.2784 17.4875 69.2465 17.6716 68.0633 17.6716C66.8595 17.6716 65.8139 17.4875 64.9265 17.1193C64.046 16.7512 63.3134 16.2262 62.7286 15.5444C62.1508 14.8626 61.7174 14.0479 61.4285 13.1002C61.1396 12.1525 60.9951 11.1026 60.9951 9.95036C60.9951 8.40952 61.2496 7.06641 61.7587 5.92101C62.2746 4.76879 63.0554 3.87565 64.101 3.24159C65.1535 2.60071 66.4812 2.28027 68.084 2.28027C69.6524 2.28027 70.956 2.5973 71.9947 3.23136C73.0334 3.86542 73.8108 4.75856 74.3267 5.91078C74.8495 7.05618 75.1109 8.40952 75.1109 9.97081ZM63.5954 9.97081C63.5954 11.123 63.7536 12.1218 64.0701 12.9673C64.3865 13.8059 64.8715 14.4536 65.525 14.9103C66.1854 15.3603 67.0315 15.5853 68.0633 15.5853C69.1021 15.5853 69.9482 15.3603 70.6017 14.9103C71.2552 14.4536 71.7367 13.8059 72.0463 12.9673C72.3559 12.1218 72.5106 11.123 72.5106 9.97081C72.5106 8.21862 72.1564 6.84824 71.4478 5.85965C70.7462 4.86424 69.6249 4.36654 68.084 4.36654C67.0521 4.36654 66.2026 4.59153 65.5353 5.0415C64.8749 5.49148 64.3865 6.13577 64.0701 6.97437C63.7536 7.80614 63.5954 8.80496 63.5954 9.97081Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M84.862 17.467L80.5179 4.98014H80.425C80.4456 5.25968 80.4697 5.64148 80.4972 6.12554C80.5247 6.60961 80.5488 7.12777 80.5694 7.68001C80.5901 8.23226 80.6004 8.76064 80.6004 9.26516V17.467H78.351V2.51549H81.8283L86.0073 14.4501H86.0692L90.3927 2.51549H93.8598V17.467H91.4968V9.14244C91.4968 8.68565 91.5037 8.19135 91.5174 7.65956C91.5381 7.12777 91.5587 6.62325 91.5794 6.146C91.6069 5.66875 91.6275 5.28695 91.6413 5.0006H91.5587L87.0495 17.467H84.862Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M110.421 17.467H107.377L99.989 5.53239H99.8961C99.9236 5.93464 99.9477 6.36076 99.9684 6.81074C99.9959 7.26072 100.017 7.72433 100.03 8.20158C100.051 8.67883 100.068 9.1629 100.082 9.65378V17.467H97.8324V2.51549H100.856L108.234 14.3683H108.306C108.292 14.0206 108.275 13.6218 108.254 13.1718C108.234 12.7218 108.213 12.2582 108.192 11.781C108.178 11.2969 108.168 10.8299 108.161 10.3799V2.51549H110.421V17.467Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M114.383 17.467V2.51549H116.86V17.467H114.383Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1559_11397",
    x1: 36.4973,
    y1: 0.0646885,
    x2: 48.3827,
    y2: 12.5157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF3B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CFFF3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFF3B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1559_11397",
    x1: 24.5272,
    y1: 11.9583,
    x2: 36.4195,
    y2: 0.0604171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF3B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CFFF3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFF3B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1559_11397",
    x1: 12.039,
    y1: 0.064632,
    x2: 23.924,
    y2: 12.5156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF3B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CFFF3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFF3B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1559_11397",
    x1: 0.0660376,
    y1: 11.9583,
    x2: 11.9584,
    y2: 0.0604168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF3B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CFFF3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFF3B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1559_11397",
    x1: 49.0179,
    y1: 11.9825,
    x2: 36.5534,
    y2: 24.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF3B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CFFF3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFF3B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1559_11397",
    x1: 24.53,
    y1: 24.4426,
    x2: 36.9755,
    y2: 12.5573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF3B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CFFF3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFF3B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1559_11397",
    x1: 12.039,
    y1: 11.9854,
    x2: 24.5034,
    y2: 24.4499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF3B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CFFF3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFF3B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1559_11397",
    x1: 11.9597,
    y1: 24.4998,
    x2: -0.491327,
    y2: 12.6147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF3B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CFFF3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFF3B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1559_11397",
    x1: 36.4987,
    y1: 48.9572,
    x2: 48.9635,
    y2: 36.4986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF3B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CFFF3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFF3B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1559_11397",
    x1: 24.5258,
    y1: 36.5029,
    x2: 36.9709,
    y2: 48.3824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF3B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CFFF3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFF3B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1559_11397",
    x1: 12.0404,
    y1: 48.9573,
    x2: 24.5049,
    y2: 36.4987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF3B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CFFF3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFF3B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1559_11397",
    x1: 0.0646324,
    y1: 36.5029,
    x2: 12.5098,
    y2: 48.3824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF3B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CFFF3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFF3B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1559_11397",
    x1: 48.965,
    y1: 36.4724,
    x2: 37.0799,
    y2: 24.0214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF3B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CFFF3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFF3B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1559_11397",
    x1: 24.5272,
    y1: 24.5252,
    x2: 36.4195,
    y2: 36.4234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF3B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CFFF3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFF3B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1559_11397",
    x1: 12.039,
    y1: 36.4697,
    x2: 23.924,
    y2: 24.0186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF3B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CFFF3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFF3B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1559_11397",
    x1: 11.9597,
    y1: 24.5238,
    x2: 0.0617659,
    y2: 36.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF3B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CFFF3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFF3B",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandscapeLogo);
export default __webpack_public_path__ + "static/media/landscapeLogo.efdea044775e1c2a39a317b9a779b47f.svg";
export { ForwardRef as ReactComponent };